import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";
import { useGetDeliveryByProcessQuery } from "@/services/backend/deliveries/delivery/service";
import { useGetInspectionRulesQuery } from "@/services/backend/rules/service";
import { PersistenceStateUsingContext } from "@/shared/persistence-state/persistence-state-info";
import {
  ArtefactPage,
  ArtefactPageActions,
  ArtefactPageContent,
  ArtefactPageHeader,
  ArtefactPageNavigation,
  ArtefactPageNavigationLink,
  ArtefactPageNavigationOutlet,
} from "@/shared/service-manager/default-ui/artefact-page/artefact-page";
import { useParams } from "react-router";
import CreateDocumentationButton from "./create-documentation-button";
import { ArtefactNotReadyAlert } from "@/shared/service-manager/artefact/artefact-sheet";
import { useErrArtefactNotReady } from "@/shared/service-manager/artefact/err-artefact-not-ready";

export function DeliveryIndexRoute() {
  const canAccess = useFeatureAuth("inspections.documentation.create");
  const { customerId, processId } = useParams();
  const { data } = useGetDeliveryByProcessQuery({
    processId: processId as string,
  });
  const { data: rule } = useGetInspectionRulesQuery({ processId: processId! });
  const { notReadyError } = useErrArtefactNotReady();

  const links = [
    {
      to: "status",
      label: "Status",
    },
    {
      to: "sampling-metadata",
      label: "Probenahmedaten",
    },
  ];

  if (rule && rule.hasActiveAirSampling) {
    links.push({
      to: "active-air-microbial",
      label: "aLK",
    });
  }

  return (
    <ArtefactPage>
      <ArtefactPageHeader>
        <ArtefactPageNavigation>
          {links.map((link) => (
            <ArtefactPageNavigationLink to={link.to} key={link.to}>
              {link.label}
            </ArtefactPageNavigationLink>
          ))}
        </ArtefactPageNavigation>
        <ArtefactPageActions>
          <PersistenceStateUsingContext />
          {data != null && !data.immutable && (
            <CreateDocumentationButton
              customerId={customerId!}
              processId={processId!}
              deliveryId={data.id}
              disabled={!canAccess}
            />
          )}
        </ArtefactPageActions>
      </ArtefactPageHeader>
      <ArtefactPageContent>
        <ArtefactNotReadyAlert error={notReadyError} artefact="Lieferung" />
        <ArtefactPageNavigationOutlet />
      </ArtefactPageContent>
    </ArtefactPage>
  );
}
